export default {
    no_session: "没有可用的应用",
    new_messages: "查看新消息",
    send_to: "发送给",

    loading: "加载中...",
};
